<div class="tw-bg-white tw-p-4 hb-group:tw-p-0 md:tw-p-8">
  @if (isHbGroup) {
    <ia-info-banner
      [size]="'standard'"
      [banner]="'Default'"
      [titleAriaLevel]="1"
      [bannerType]="undefined"
      [icon]="'nhb:bulb_nhb'"
      class="tw-rounded-md tw-border-0 tw-bg-seasalt tw-text-hb-base part:tw-bg-mint-cream mb-group:tw-text-eerie-black"
    >
      <div class="tw-flex tw-flex-col">
        <div contentRef>
          <p class="hb-group:tw-text-hb-base">
            {{ 'screens.onboarding.section1.info' | translate }}
          </p>
        </div>
      </div>
    </ia-info-banner>
  }

  <div class="tw-flex tw-flex-col hb-group:tw-mt-8">
    <p
      class="tw-text-xl tw-font-bold hb-group:tw-font-hello-type-next hb-group:tw-text-lg hb-group:tw-font-medium hb-group:tw-text-midnight-green"
      [innerHTML]="'screens.onboarding.section1.title' | translate"
    ></p>

    <div class="hb-group:tw-pb-8">
      <p
        class="tw-mb-8 tw-mt-5 tw-text-base tw-font-semibold hb-group:tw-font-hello-type-next hb-group:tw-text-hb-md hb-group:tw-font-medium hb-group:tw-text-midnight-green"
        [innerHTML]="'screens.onboarding.section1.description' | translate"
      ></p>

      <div class="tw-flex tw-flex-col tw-gap-7 hb-group:tw-gap-0">
        @for (case of 'screens.onboarding.section1.cases' | translate; track case) {
          <ia-resil-contrats-expandabled-item
            [title]="case.title"
            [iconName]="'messages_dots'"
            [showIcon]="!isHbGroup"
          >
            <div [innerHTML]="case.content" class="tw-my-10 hb-group:tw-my-3"></div>
          </ia-resil-contrats-expandabled-item>
        }
      </div>

      <div class="tw-mt-12.5">
        <p
          class="tw-font-bold hb-group:tw-font-hello-type-next hb-group:tw-text-hb-md hb-group:tw-font-medium hb-group:tw-text-midnight-green"
          [innerHTML]="'screens.onboarding.section2.title' | translate"
        ></p>
        <ol
          class="tw-mt-5 tw-flex tw-list-inside tw-list-decimal tw-flex-col tw-gap-3 hb-group:tw-gap-6 hb-group:tw-text-midnight-green"
        >
          @for (step of 'screens.onboarding.section2.steps' | translate; track step) {
            @if (isHbGroup) {
              <div class="tw-flex tw-flex-row tw-items-center tw-gap-3">
                <div
                  class="tw-flex tw-size-8 tw-items-center tw-justify-center tw-rounded-xl tw-bg-[#e1eff4] tw-p-3 tw-font-semibold hb-group:tw-font-hello-type-next"
                >
                  {{ $index + 1 }}
                </div>
                <div class="tw-text-hb-base">{{ step }}</div>
              </div>
            } @else {
              <li>
                {{ step }}
              </li>
            }
          }
        </ol>
      </div>

      <div class="tw-mt-7">
        <p
          class="tw-font-semibold hb-group:tw-font-hello-type-next hb-group:tw-text-hb-base hb-group:tw-font-medium hb-group:tw-text-midnight-green"
          [innerHTML]="'screens.onboarding.section3.title' | translate"
        ></p>
      </div>
    </div>
  </div>
</div>
@if ({ isLoading: customerInformationIsLoading$ | async }; as vm) {
  <div class="tw-mt-5 tw-flex tw-justify-center md:tw-justify-end">
    <button
      (click)="onNext()"
      [disabled]="!!vm.isLoading"
      [isProcessing]="!!vm.isLoading"
      class="tw-h-10.5 tw-font-semibold hb-group:tw-uppercase"
      iaButton
      id="link-onboarding-start"
      data-test-id="link-onboarding-start"
      type="button"
      variant="primary"
      size="large"
    >
      {{ 'screens.onboarding.button.start' | translate }}
    </button>
  </div>
}
